"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));

var Slider_1 = __importDefault(require("@material-ui/core/Slider"));

var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));

var FormGroup_1 = __importDefault(require("@material-ui/core/FormGroup"));

var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));

var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));

var context_1 = require("../Form/context");

var partial_1 = __importDefault(require("lodash/partial"));

exports.useFormFieldContext = function (name) {
  var _a = context_1.useFormContext(),
      _b = _a[0],
      values = _b.values,
      errors = _b.errors,
      touched = _b.touched,
      _c = _a[1],
      setTouched = _c.setTouched,
      setValue = _c.setValue,
      setError = _c.setError;

  var state = {
    value: values[name],
    error: errors[name],
    hasError: !!errors[name],
    touched: !!touched[name]
  };
  var actions = {
    setValue: partial_1.default(setValue, name),
    setTouched: partial_1.default(setTouched, name),
    setError: partial_1.default(setError, name)
  };
  return {
    state: state,
    actions: actions
  };
};

exports.FormField = react_1.forwardRef(function (_a, ref) {
  var name = _a.name,
      _b = _a.component,
      Component = _b === void 0 ? TextField_1.default : _b,
      props = __rest(_a, ["name", "component"]);

  var _c = exports.useFormFieldContext(name || ''),
      _d = _c.state,
      value = _d.value,
      error = _d.error,
      hasError = _d.hasError,
      _e = _c.actions,
      setTouched = _e.setTouched,
      setValue = _e.setValue;

  var handleChange = function handleChange(ev) {
    if (ev.target.type === 'number') {
      setValue(Number(ev.target.value));
    } else {
      setValue(ev.target.value);
    }
  };

  return react_1.default.createElement(Component, __assign({}, props, {
    ref: ref,
    name: name,
    value: value,
    error: hasError,
    helperText: error || props.helperText,
    onBlur: function onBlur() {
      return setTouched();
    },
    onChange: handleChange
  }));
});

exports.SliderField = function (_a) {
  var name = _a.name,
      _b = _a.component,
      Component = _b === void 0 ? Slider_1.default : _b,
      props = __rest(_a, ["name", "component"]);

  var _c = exports.useFormFieldContext(name || ''),
      _d = _c.state,
      value = _d.value,
      error = _d.error,
      hasError = _d.hasError,
      _e = _c.actions,
      setTouched = _e.setTouched,
      setValue = _e.setValue;

  var handleChange = function handleChange(ev, value) {
    setValue(value);
  };

  return react_1.default.createElement(Component, __assign({}, props, {
    name: name,
    value: value,
    onBlur: function onBlur() {
      return setTouched;
    },
    onChange: handleChange
  }));
};

exports.CheckboxField = function (_a) {
  var name = _a.name,
      label = _a.label,
      labelProps = _a.labelProps,
      helperText = _a.helperText,
      _b = _a.component,
      Component = _b === void 0 ? Checkbox_1.default : _b,
      props = __rest(_a, ["name", "label", "labelProps", "helperText", "component"]);

  var _c = exports.useFormFieldContext(name || ''),
      _d = _c.state,
      value = _d.value,
      error = _d.error,
      hasError = _d.hasError,
      setValue = _c.actions.setValue;

  var handleChange = function handleChange(ev) {
    setValue(ev.target.checked);
  };

  return react_1.default.createElement(FormControl_1.default, {
    required: true,
    error: hasError,
    component: "fieldset"
  }, react_1.default.createElement(FormGroup_1.default, null, react_1.default.createElement(FormControlLabel_1.default, __assign({
    control: react_1.default.createElement(Checkbox_1.default, __assign({
      checked: value,
      onChange: handleChange,
      value: name,
      name: name
    }, props)),
    label: label
  }, labelProps))), error || helperText ? react_1.default.createElement(FormHelperText_1.default, {
    variant: "outlined"
  }, error || helperText) : null);
};